module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-BoldItalic.894abaa5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-BoldItalic.woff
// module id = 931
// module chunks = 0